import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as Highcharts from 'highcharts';
import { ReportCategoryRank } from '../../models/report.model';
import { LookupService } from '../../services/lookups/lookup.service';

@Component({
  selector: 'app-top-five-report-categories',
  templateUrl: './top-five-report-categories.component.html',
  styleUrls: ['./top-five-report-categories.component.css']
})
export class TopFiveReportCategoriesComponent implements OnInit {
  highcharts: typeof Highcharts = Highcharts;
  chartOptions: any;
  noResult: boolean;
  @Input() selectedCountryId: number;

  constructor(private lookupService: LookupService,
              private router: Router) { }

  ngOnInit(): void {
    var router = this.router;
    var selectedCountryId = this.selectedCountryId;
    this.chartOptions = {
      chart: {
        type: 'pie',
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        width: 400,
        height: 250,
        options3d: {
          enabled: true,
          alpha: 45,
          beta: 0
        }
      },
      title: null,
      accessibility: {
        point: {
          valueSuffix: '%'
        }
      },
      tooltip: {
        pointFormat: '{point.percentage:.0f}%'
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          depth: 35,
          dataLabels: {
            enabled: false,
            format: '{point.name}'
          },
          center: [90, 90],
          size: '100%',
          point: {
            events: {
              legendItemClick: function (event: any) {
                router.navigate(['search'], { queryParams: {searchCategory: event.target.id, searchCountry: selectedCountryId} });
                return false;
              }
            },
            showInLegend: true,
          },
        },
      },
      credits: {
        enabled: false
      },
      exporting: {
        enabled: false
      },
      legend: {
        align: 'left',
        verticalAlign: 'top',
        layout: 'vertical',
        itemMarginBottom: 15,
        squareSymbol: true,
        symbolRadius: 0,
        width: '50%',
        itemStyle: {"color": "#162e52", "fontSize": "16px", "fontWeight": "700", "font-family": "Source Sans Pro","text-decoration": "none"},
        itemHoverStyle:{"text-decoration": "underline"},
        x: -10,
        y: 30
      },
      series: [{
        type: 'pie',
        showInLegend: true,
        name: '',
        data: []
      }]
    };
  }

  getTopFiveCategories(selectedCountryId, appUserId) {
    this.lookupService.GetTopFiveReportCategories(selectedCountryId, appUserId)
      .pipe()
      .subscribe((result: ReportCategoryRank[]) => {
        this.generatePieChart(result);
      }
      )
  }


  generatePieChart(result: ReportCategoryRank[]) {

   var router = this.router;
   var selectedCountryId = this.selectedCountryId;

    if (result.length != 0) {
      this.noResult = false;
      this.chartOptions = {
        chart: {
          type: 'pie',
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false,
          width: 400,
          height: 250,
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0
          }
        },
        title: null,
        accessibility: {
          point: {
            valueSuffix: '%'
          }
        },
        tooltip: {
          pointFormat: '{point.percentage:.0f}%'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            depth: 35,
            dataLabels: {
              enabled: false,
              format: '{point.name}'
            },
            center: [90, 90],
            size: '100%',
            point: {
              events: {
                legendItemClick: function (event: any) {
                  router.navigate(['search'], { queryParams: {searchCategory: event.target.id, searchCountry: selectedCountryId} });
                  return false;
                }
              },
              showInLegend: true,
            },
          },
        },
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        },
        legend: {
          align: 'left',
          verticalAlign: 'top',
          layout: 'vertical',
          itemMarginBottom: 15,
          squareSymbol: true,
          symbolRadius: 0,
          width: '50%',
          itemStyle: {"color": "#162e52", "fontSize": "16px", "fontWeight": "700", "font-family": "Source Sans Pro"},
          x: -10,
          y: 30
        },
        series: [{
          type: 'pie',
          showInLegend: true,
          name: '',
          data: [
          ]
        }]
      };
      if (result.length > 0) {
        this.chartOptions.series[0].data.push({
          name: result[0].categoryName,
          y: result[0].categoryCount,
          data: result[0].categoryCount,
          id:result[0].categoryId,
          selected: true,
          color: '#b88181'
        })
      }
      if (result.length > 1) {
        this.chartOptions.series[0].data.push({
          name: result[1].categoryName,
          y: result[1].categoryCount,
          data: result[1].categoryCount,
          id:result[1].categoryId,
          selected: true,
          color: '#c9b87f'
        })
      }
      if (result.length > 2) {
        this.chartOptions.series[0].data.push({
          name: result[2].categoryName,
          y: result[2].categoryCount,
          data: result[2].categoryCount,
          id:result[2].categoryId,
          selected: true,
          color: '#97b9c4'
        })
      }
      if (result.length > 3) {
        this.chartOptions.series[0].data.push({
          name: result[3].categoryName,
          y: result[3].categoryCount,
          data: result[3].categoryCount,
          id:result[3].categoryId,
          selected: true,
          color: '#765087'
        })
      }
      if (result.length > 4) {
        this.chartOptions.series[0].data.push({
          name: result[4].categoryName,
          y: result[4].categoryCount,
          data: result[4].categoryCount,
          id:result[4].categoryId,
          selected: true,
          color: '#717d5e'
        })
      }
    }

    else {
      this.noResult = true;
    }
  }

}
